export const MainActions = {
  DUMMY_ACTION:'DUMMY_ACTION'
}

export const dummyAction = () => ({
  type:MainActions.DUMMY_ACTION,
});



// WEBPACK FOOTER //
// ./src/modules/main/actions.js